import { formatAtDateTime } from '#app/helpers/dateFieldTransforms';
import React, { Fragment } from 'react';
import { useAppDispatch, useAppSelector } from '#app/hooks/useAppStore';
import { Button } from 'finform';
import { Body, BodyBold } from '#app/components/Text/styles';
import { NotificationDivider, NotificationRow } from './../DropdownContent/styles';
import { useNavigate } from 'react-router-dom';
import { routes } from '#app/constants/routes';
import { setActiveNotificationForModal } from '#app/actions/interface';
import { handleLogClick } from '#app/pages/NotificationPage/utils/notificationHandlers';

const NotificationContent = ({ notifications }) => {
  const dispatch = useAppDispatch();
  const client = useAppSelector((s) => s.interfaceComponents?.client ?? null);
  const navigate = useNavigate();

  const displayedNotifications = Array.isArray(notifications) ? notifications.slice(0, 5) : [];

  const handleNotificationClick = (item) => {
    if (!client?.id) return;
    handleLogClick(item, client.id, (payload) => dispatch(setActiveNotificationForModal(payload)));
  };

  return (
    <div style={{ display: 'flex', padding: '10px 12px 0', flexWrap: 'wrap', width: '400px' }}>
      {displayedNotifications.map((item) => {
        const shortContent =
          item.content?.length > 126 ? item.content.slice(0, 125) + '...' : item.content || '';
        return (
          <Fragment key={item.id}>
            <NotificationRow
              style={{ cursor: client?.id ? 'pointer' : undefined }}
              onClick={() => handleNotificationClick(item)}
            >
              <BodyBold>{shortContent}</BodyBold>
              <Body style={{ marginTop: '6px' }}>{formatAtDateTime(item?.created_at)}</Body>
            </NotificationRow>
            <NotificationDivider />
          </Fragment>
        );
      })}
      <div style={{ flexBasis: '100%', justifyContent: 'center', display: 'flex' }}>
        <Button
          style={{ width: '100%', marginTop: '4px', marginBottom: '10px' }}
          className="style1"
          slim
          onClick={() => navigate(routes.common.notifications)}
        >
          Посмотреть все
        </Button>
      </div>
    </div>
  );
};

export default NotificationContent;
